export { defaultMarket, dangerouslySetCurrentMarket, getCurrentMarket, getAllMarketCodes, getMarketByCode, globalMarket, supportedMarketCodes, supportedMarkets, getCurrentMarketTemplateLocales, } from './config';
